export default {
  ABOUT: "about",
  FEATURE: "feature",
  SPONSOR: "sponsor",
  TRAILER: "trailer",
};
